<template>
  <div class="customerTab">
    <div class="left tabList" v-if="customerTabStat !== 'ALL' " :class="scrollX ? 'scroolx' : '' ">
      <div ref="tabDiv" class="tabDiv">
        <v-btn v-for="(group, index) in customerGroupList" :key="index" depressed
        @click="groupChange(group.id, group.searchData)"
        :class="{ 'on' : selectGroupId === group.id }"
        >
          <img :src="selectGroupId === group.id ? group.imageUrl+'_active.svg' : group.imageUrl+'.svg'"
            alt="lineアイコン"
            width="18"
            height="18"
          >
          <span>{{group.name}}</span>
        </v-btn>
      </div>
    </div>
    <div class="tabRight">
      <v-btn outline class="medium down emphasis" @click="openGroupDialog('NEW');">グループ追加</v-btn>
      <!-- <v-btn outline class="UXbtn medium down">グループ削除</v-btn> -->
      <v-select
        v-model="groupType"
        :items="groupManagement"
        item-value="value"
        item-text="name"
        class="UXselect groupInput medium down right"
        hide-details
        outline
        solo
        :disabled="selectGroupId === ''"
        @change="groupUpdateAlert()"
        no-data-text="データがありません。"
      ></v-select>
    </div>
  </div>
</template>

<script>
// import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'customerTab',
  components: {
  },
  props: {
    customerTabStat: String,
    pagination: Object
  },
  data () {
    return {
      selectGroupId: '',
      groupType: 'default',
      groupManagement: [
        {name: 'グループ設定', value: 'default'},
        // {name: 'この設定のまま更新', value: 'SetAsIs'},
        {name: 'グループ設定の変更', value: 'ChangeSetting'},
        {name: 'グループ削除', value: 'CancelSetting'}
      ],
      customerGroupList: [],
      basicUrl: '//public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/',
      scrollX: false
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters(['currentBrandId', 'agentMappingBrandViews']),
    channelType () {
      return this.customerTabStat === 'LINE' ? 'LINE' : 'WEB_CHAT'
    }
  },
  destroyed () {
  },
  created () {
    this.brandId = this.currentBrandId || this.agentMappingBrandViews.sort((s1, s2) => s1.brandId - s2.brandId)[0].brandId
  },
  mounted () {
    this.getGroupList()
    this.setSelectGroupId()
  },
  methods: {
    openGroupDialog (type) {
      this.$emit('dialogOpen', type, true, false)
    },
    getGroupList (groupId) {
      this.axios.get('/api/groupCustomerInfo/getGroupListInfo', {
        params: {
          brandId: this.brandId,
          customerStat: this.channelType
        }
      }).then(result => {
        if (result.status !== 200 || result.data.code !== 0) {
          console.log(result.data.message)
        } else {
          let data = result.data.data
          let imageUrl = this.basicUrl + this.customerTabStat.toLowerCase()
          // 생성/변경시 검색조건 저장
          let groupSearchData = ''
          this.customerGroupList = [{id: '', name: '全体', imageUrl: imageUrl, searchData: ''}]
          data.forEach(d => {
            this.customerGroupList.push({id: d.groupCustomerInfoId, name: d.groupName, imageUrl: imageUrl, searchData: d.searchData})
            groupSearchData = groupId === d.groupCustomerInfoId ? d.searchData : ''
          })
          if (groupId) {
            this.groupChange(groupId, groupSearchData)
          }
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    deleteGroup () {
      this.axios.delete('/api/groupCustomerInfo/deleteGroupInfo', {
        params: {
          brandId: this.brandId,
          groupCustomerId: this.selectGroupId
        }
      }).then(result => {
        if (result.status !== 200 || result.data.code !== 0) {
          console.log(result.data.message)
        } else {
          this.selectGroupId = ''
          this.$alertMsg('グループが削除されました。')
          this.getGroupList()
          this.groupChange(this.selectGroupId)
        }
        setTimeout(() => {
          this.returnOption()
        })
      }).catch(err => {
        console.log(err.message)
      })
    },
    groupChange (groupId, searchData) {
      let item = {}
      this.selectGroupId = groupId
      if (groupId) {
        item = {
          groupType: this.groupType,
          selectGroupId: this.selectGroupId,
          searchData: JSON.parse(searchData),
          firstSearch: true
        }
        this.$emit('groupSeting', item)
      } else {
        item = {
          groupType: this.groupType,
          selectGroupId: this.selectGroupId,
          firstSearch: true
        }
        this.$emit('resetParam')
        this.$emit('groupSeting', item)
      }
    },
    groupUpdateAlert () {
      let print = this.printAlert(this.groupType)
      if (print === '変更') {
        this.groupUpdateOpen()
      } else {
        this.$eventBus.$emit('DialogPopup', {
          useDialog: true,
          getBtnCount: 2,
          messageHTML: `<dl class="txt"><dd>グループを${print}しますか？</dd></dl>`,
          getButtonEvent: () => this.groupUpdateOpen(),
          getLeftBtnEvent: () => this.returnOption()
        })
      }
    },
    groupUpdateOpen () {
      if (this.groupType === 'ChangeSetting') {
        let item = {
          groupType: this.groupType,
          selectGroupId: this.selectGroupId,
          firstSearch: false
        }
        this.$emit('groupSeting', item)
      } else if (this.groupType === 'CancelSetting') {
        let item = {
          groupType: this.groupType,
          selectGroupId: '',
          firstSearch: true
        }
        this.$emit('groupSeting', item)
        this.deleteGroup()
      }
      setTimeout(() => {
        this.returnOption()
      })
    },
    returnOption () {
      this.groupType = 'default'
    },
    printAlert (status) {
      if (status === 'SetAsIs') {
        return `更新`
      } else if (status === 'CancelSetting') {
        return `削除`
      } else if (status === 'ChangeSetting') {
        return `変更`
      }
    },
    setSelectGroupId () {
      const key = 'CUSTOMER_LIST_OPTION'
      const option = localStorage.getItem(key)
      const jsonArr = JSON.parse(option)
      let tabStat = this.customerTabStat
      const data = jsonArr[tabStat]
      if (data.selectGroupId) {
        this.selectGroupId = data.selectGroupId
        let item = {
          groupType: '',
          selectGroupId: this.selectGroupId,
          firstSearch: true
        }
        this.$emit('groupSeting', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
    background-color: transparent;
  }
  .customerTab{
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-bottom: 1px solid #e8e8e8;
    background: #FAFAFA;
    .left .v-btn {
      position: relative;
      height: 54px;
      margin: 0!important;
      border-right: 1px solid #e8e8e8;
      border-radius: 0;
      -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
      padding: 7px, 9px, 7px, 9px;
      background-color: #FAFAFA;
      min-width: 68px!important;
      font-weight: 400;
      text-transform: none ;
      .v-btn__content img {
        margin-right: 2px;
      }
    }
    .tabList {
      width: calc(100% - 310px);
      white-space: nowrap;
      .tabDiv {
        overflow-x: auto;
        max-width: 1200px;
        border-right: 1px solid #ddd;
        &::-webkit-scrollbar {
          height: 7px;
        }
        &::-webkit-scrollbar-track {
          background: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background: #d1d1d1;
          border: 1px solid #fafafa;
          border-radius: 10px;
        }
      }
    }
  }
    .scroolx {
    overflow-x: auto;
  }
  .customerTab .tabRight .v-btn {
    margin: 0!important;
  }
  .tabRight {
    display: flex;
    align-items: flex-start;
    justify-content: end;
    padding-right: 25px;
    width: 310px;
    .v-input--is-disabled  {
    }
  }
  .on {
    font-weight: bold;
    background-color: #FFFFFF!important;
    border-bottom: none!important;
  }
  .down {
    top: 10px;
  }
  .emphasis {
    color: #FF8C8C!important;
    border: 3px solid #FF8C8C!important;
    border-radius: 3px!important;
    background: #fff!important;
  }
  .groupInput {
    background: #fff;
    max-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/customer/components/customerTab.vue